import { fetchFromRTM } from './index';
import * as constants from './constants';
import './typedef';

class TemplateResolver {
  constructor(connection) {
    this.connection = connection;
  }

  /**
   * Creates a template
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-create/)
   * @param {Object} payload
   * @param {string} payload.workspaceId
   * @param {string} payload.templateType
   * @param {array} payload.categories
   * @param {string} payload.config
   * @param {string} payload.description
   * @param {string} payload.name
   * @param {string} payload.thumbnail
   * @param {string} payload.pluginId
   * @param {string} payload.metadata
   * 
   * @returns {Promise.<[TemplateDto]>}
   */

  authorTemplateCreate = async ({
    workspaceId,
    templateType,
    categories,
    config,
    description,
    name,
    thumbnail,
    pluginId,
    metadata,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_TEMPLATE_CREATE,
      workspaceId,
      templateType,
      categories,
      config,
      description,
      name,
      thumbnail,
      pluginId,
      metadata,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_TEMPLATE_CREATE_OK,
      constants.RTM_AUTHOR_TEMPLATE_CREATE_ERROR,
    );
    return response.template;
  };

  /**
   * Updates a template
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-update/)
   * @param {Object} payload
   * @param {string} payload.templateId
   * @param {string} payload.templateType
   * @param {array} payload.categories
   * @param {string} payload.config
   * @param {string} payload.description
   * @param {string} payload.name
   * @param {string} payload.thumbnail
   * @param {string} payload.pluginId
   * @param {string} payload.metadata
   * 
   * @returns {Promise.<[TemplateDto]>}
   */

  authorTemplateUpdate = async ({
    templateId,
    templateType,
    categories,
    config,
    description,
    name,
    thumbnail,
    pluginId,
    metadata,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_TEMPLATE_UPDATE,
      templateId,
      templateType,
      categories,
      config,
      description,
      name,
      thumbnail,
      pluginId,
      metadata,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_TEMPLATE_UPDATE_OK,
      constants.RTM_AUTHOR_TEMPLATE_UPDATE_ERROR,
    );
    return response.template;
  };


  /**
  * Get list of all templates
  *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-list/)
  * 
  * @returns {Promise.<[TemplateDto]>}
  */

  authorTemplateList = async () => {
    const message = {
      type: constants.RTM_AUTHOR_TEMPLATE_LIST,
    };
    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_TEMPLATE_LIST_OK,
      constants.RTM_AUTHOR_TEMPLATE_LIST_ERROR,
    );
    return response.templates;
  };


  /**
   * Get a template by its templateId
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-get)
   * @param {string} templateId
   * 
   * @returns {Promise.<TemplateDto>}
   */

  authorTemplateGet = async (templateId) => {
    const message = {
      type: constants.RTM_AUTHOR_TEMPLATE_GET,
      templateId,
    };
    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_TEMPLATE_GET_OK,
      constants.RTM_AUTHOR_TEMPLATE_GET_ERROR,
    );
    return response.template;
  };

  /**
   * Filter templates by its templateType and category
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-templates-filter)
   * @param {string} templateType
   * @param {string} category
   * 
   * @returns {Promise.<[TemplateDto]>}
   */

  authorTemplatesFilter = async (templateType, category) => {
    const message = {
      type: constants.RTM_AUTHOR_TEMPLATES_FILTER,
      templateType,
      category,
    };
    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_TEMPLATES_FILTER_OK,
      constants.RTM_AUTHOR_TEMPLATES_FILTER_ERROR,
    );
    return response.templates;
  };

  /**
   * Filter the templates by type
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-templates-filter-type/)
   * @param {string} templateType
   *
   * @returns {Promise.<[TemplateDto]>}
   */

    authorTemplatesFilterType = async (templateType) => {
      const message = {
        type: constants.RTM_AUTHOR_TEMPLATES_FILTER_TYPE,
        templateType,
      };
      const response = await fetchFromRTM(
        this.connection,
        message,
        constants.RTM_AUTHOR_TEMPLATES_FILTER_TYPE_OK,
        constants.RTM_AUTHOR_TEMPLATES_FILTER_TYPE_ERROR,
      );
      return response.templates;
    };

    /**
   * Delete template(s) by their templateId
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-template-delete)
   * @param {Array<string>} templateIds
   * 
   * @returns {Promise.<void>}
   */

  authorTemplateDelete = async (templateIds) => {
    const message = {
      type: constants.RTM_AUTHOR_TEMPLATE_DELETE,
      templateIds,
    };
    await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_TEMPLATE_DELETE_OK,
      constants.RTM_AUTHOR_TEMPLATE_DELETE_ERROR,
    );
  };
}

export default TemplateResolver;
